import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Button } from '@upme/ui/components/button';
import { canEditGlobalCatalog } from '../../../features/auth/admin-capabilities';
import { useAuth } from '../../../features/auth/auth-context';
import { listPlaceCategoriesOptions } from '../../../features/places/api/place-categories.queries';
import { PlaceCategoriesTable } from '../../../features/places/components/place-categories-table';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/place-categories/')({
  loader: ({ context }) => context.queryClient.ensureQueryData(listPlaceCategoriesOptions()),
  component: PlaceCategoriesIndexPage,
});

function PlaceCategoriesIndexPage() {
  const { data: categories } = useSuspenseQuery(listPlaceCategoriesOptions());
  const { adminRoles } = useAuth();
  const canEdit = canEditGlobalCatalog(adminRoles);
  return (
    <div>
      <PageHeader
        title="Категории мест"
        description="Справочник категорий, к которым привязываются места."
        actions={
          canEdit ? (
            <Button asChild>
              <Link to="/place-categories/new">Новая категория</Link>
            </Button>
          ) : null
        }
      />
      {!canEdit && (
        <p className="text-sm text-muted-foreground mb-4">Редактировать категории может только SUPERADMIN.</p>
      )}
      <PlaceCategoriesTable categories={categories} />
    </div>
  );
}
